import { Divider, IconButton, InputAdornment } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import SearchIcon from '@material-ui/icons/Search'
import { CITIES, ESTADO, NACIONALIDAD, PROVINCIAS, TIPO_RESPONSABLE } from 'Constants'

const normalizeText = (val) => {
  if (val === null || val === undefined) return ''
  return String(val)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toUpperCase()
}

export const Step1 = (info, handleSubmitCode, handleChange, isLoading, isFromSearch) => {
  const provinciaId = PROVINCIAS.find(
    (p) => normalizeText(p.provincia) === normalizeText(info.provincia)
  )?.id
  const localidadesFiltradas = CITIES.filter((city) => city.provincia_id === provinciaId)
  const estadoCliente = ESTADO.find((e) => e.value === info.estado)?.label
  const defaultNacionalidad = NACIONALIDAD.find((n) => n.label === 'LOCAL').label
  const isExtranjero = info.nacionalidad === 'EXTRANJERO'

  const searchEndAdornment = (
    <InputAdornment position="end">
      <Divider orientation="vertical" style={{ height: 28 }} />
      <IconButton color="primary" onClick={handleSubmitCode} disabled={isLoading}>
        {isLoading ? (
          <CircularProgress
            style={{
              color: 'primary',
              width: '24px',
              height: '24px',
            }}
          />
        ) : (
          <SearchIcon />
        )}
      </IconButton>
    </InputAdornment>
  )

  return [
    {
      label: 'Nacionalidad',
      name: 'nacionalidad',
      options: NACIONALIDAD,
      optionLabel: `options["label"]`,
      optionValue: 'label',
      sm: 6,
      xs: 12,
      class: 'autocomplete',
      value: info.nacionalidad || defaultNacionalidad,
      onChange: (e) => {
        handleChange('nacionalidad', e.label)
        if (e.label === 'EXTRANJERO') {
          handleChange('tipo_responsable', 5)
          handleChange('cond_iva', 91)
        } else {
          handleChange('cond_iva', info.tipo_responsable)
        }
      },
    },
    {
      label: 'CUIT/CUIL/DNI',
      name: 'search',
      class: 'textfield',
      type: 'number',
      value: info.search,
      onChange: (e) => handleChange('search', e.target.value),
      onKeyDown: (e) => {
        if (e.key === 'Enter') handleSubmitCode()
      },
      inputProps: {
        endAdornment: searchEndAdornment,
      },
      sm: 6,
      xs: 12,
    },
    {
      label: 'Razón social',
      name: 'nombre',
      sm: 4,
      xs: 12,
      class: 'textfield',
      disabled: false,
      value: info.nombre,
      onChange: (e) => handleChange('nombre', e.target.value),
      inputProps: isFromSearch
        ? {
            readOnly: true,
          }
        : undefined,
    },
    {
      label: 'Tipo responsable',
      name: 'tipo_responsable',
      sm: 4,
      xs: 12,
      class: 'autocomplete',
      disabled: isExtranjero ? true : false,
      value: info.tipo_responsable,
      options: TIPO_RESPONSABLE,
      sortBy: 'name',
      optionLabel: `options["name"]`,
      optionValue: 'value',
      onChange: (e) => {
        handleChange('tipo_responsable', e.value)
        if (!isExtranjero) {
          handleChange('cond_iva', e.value)
        }
      },
    },
    {
      label: 'Estado',
      name: 'estado',
      sm: 4,
      xs: 12,
      class: 'textfield',
      disabled: true,
      value: estadoCliente ?? '',
      inputProps:
        estadoCliente === 'INCOBRABLE'
          ? {
              style: {
                color: '#c81e1eeb',
              },
            }
          : undefined,
    },
    {
      label: 'Provincia',
      name: 'provincia',
      optionValue: 'provincia',
      options: PROVINCIAS,
      sortBy: 'provincia',
      optionLabel: `options["provincia"]`,
      sm: 4,
      xs: 12,
      class: isExtranjero ? 'textfield' : 'autocomplete',
      disabled: isExtranjero ? true : false,
      value: isExtranjero ? (info.provincia ?? '') : info.provincia,
      onChange: (e) => {
        const nextProvincia = e?.provincia ?? ''

        if (normalizeText(nextProvincia) !== normalizeText(info.provincia)) {
          handleChange('localidad', '')
        }

        handleChange('provincia', nextProvincia)
      },
    },
    {
      label: 'Localidad',
      name: 'localidad',
      optionValue: 'localidad',
      options: localidadesFiltradas,
      sortBy: 'localidad',
      optionLabel: `options["localidad"]`,
      sm: 4,
      xs: 12,
      class: isExtranjero ? 'textfield' : 'autocomplete',
      disabled: isExtranjero ? true : !info.provincia,
      value: isExtranjero ? (info.localidad ?? '') : info.localidad,
      onChange: (e) => handleChange('localidad', e?.localidad ?? ''),
    },
    {
      label: 'Dirección',
      name: 'domicilio',
      sm: 4,
      xs: 12,
      class: 'textfield',
      disabled: isExtranjero ? true : false,
      value: info.domicilio,
      onChange: (e) => handleChange('domicilio', e.target.value),
    },
    {
      label: 'Teléfono',
      name: 'telefono',
      sm: 6,
      xs: 12,
      class: 'textfield',
      type: 'number',
      value: info.telefono,
      onChange: (e) => handleChange('telefono', e.target.value),
    },
    {
      label: 'Email',
      name: 'mail',
      sm: 6,
      xs: 12,
      class: 'textfield',
      value: info.mail,
      onChange: (e) => handleChange('mail', e.target.value),
    },
    {
      label: 'Observación',
      name: 'notas',
      sm: 12,
      xs: 12,
      class: 'textfield',
      value: info.notas,
      onChange: (e) => handleChange('notas', e.target.value),
    },
  ]
}
